'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _posts = require('../../api/posts');

var _images = require('../../api/images');

var _form3 = require('constructicon/form');

var _form4 = _interopRequireDefault(_form3);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputImage = require('constructicon/input-image');

var _inputImage2 = _interopRequireDefault(_inputImage);

var _InputModal = require('./InputModal');

var _InputModal2 = _interopRequireDefault(_InputModal);

var _inputVideo = require('constructicon/input-video');

var _inputVideo2 = _interopRequireDefault(_inputVideo);

var _section = require('constructicon/section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePostForm = function (_React$Component) {
  _inherits(CreatePostForm, _React$Component);

  function CreatePostForm(props) {
    _classCallCheck(this, CreatePostForm);

    var _this = _possibleConstructorReturn(this, (CreatePostForm.__proto__ || Object.getPrototypeOf(CreatePostForm)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      errors: [],
      height: props.height,
      image: null,
      status: null,
      video: null,
      width: props.width
    };
    return _this;
  }

  _createClass(CreatePostForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var video = this.state.video;
      var _props = this.props,
          form = _props.form,
          onSuccess = _props.onSuccess,
          pageId = _props.pageId,
          token = _props.token,
          userId = _props.userId;


      form.submit().then(function (data) {
        return Promise.resolve().then(function () {
          return (0, _values2.default)(data).every(_isEmpty2.default) && Promise.reject({
            message: 'Please include a message or an image or video.'
          });
        }).then(function () {
          return _this2.setState({ errors: [], status: 'fetching' });
        }).then(function () {
          return data.image && (0, _images.uploadImage)(data.image);
        }).then(function (image) {
          return (0, _posts.createPost)(_extends({}, data, {
            image: image,
            pageId: pageId,
            token: token,
            userId: userId,
            video: video ? video.url : data.video
          }));
        }).then(function (data) {
          _this2.setState({ status: 'fetched' });
          onSuccess(data);
        }).catch(function (error) {
          var message = (0, _get2.default)(error, 'data.error.message') || (0, _get2.default)(error, 'data.errorMessage') || (0, _get2.default)(error, 'message') || 'There was an unexpected error';
          _this2.setState({ status: 'failed', errors: [{ message: message }] });
        });
      });
    }
  }, {
    key: 'handleChangeAttachment',
    value: function handleChangeAttachment(val) {
      var _this3 = this;

      var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image';
      var _props2 = this.props,
          form = _props2.form,
          height = _props2.height,
          resizeOnUpload = _props2.resizeOnUpload,
          width = _props2.width;


      if (!val) {
        var _setState;

        this.setState((_setState = {}, _defineProperty(_setState, field, null), _defineProperty(_setState, 'width', width), _defineProperty(_setState, 'height', height), _setState));
        return form.fields[field].onChange('');
      }

      switch (typeof val === 'undefined' ? 'undefined' : _typeof(val)) {
        case 'object':
          return this.setState(_defineProperty({}, field, val));
        default:
          if (resizeOnUpload && field === 'image') {
            var image = new window.Image();
            image.src = val;
            image.onload = function () {
              _this3.setState({ width: image.width, height: image.height });
            };
          }

          return form.fields[field].onChange(val);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          errors = _state.errors,
          height = _state.height,
          image = _state.image,
          status = _state.status,
          video = _state.video,
          width = _state.width;
      var _props3 = this.props,
          buttonProps = _props3.buttonProps,
          form = _props3.form,
          formProps = _props3.formProps,
          inputProps = _props3.inputProps,
          orientationChange = _props3.orientationChange,
          resizeOnUpload = _props3.resizeOnUpload,
          submit = _props3.submit;


      return _react2.default.createElement(
        _form4.default,
        _extends({
          errors: errors,
          isLoading: status === 'fetching',
          noValidate: true,
          onSubmit: this.handleSubmit,
          submit: submit,
          autoComplete: 'off'
        }, formProps),
        _react2.default.createElement(_inputField2.default, _extends({}, form.fields.message, inputProps)),
        _react2.default.createElement(
          _section2.default,
          { tag: 'fieldset', spacing: { b: 1 } },
          _react2.default.createElement(
            _grid2.default,
            { spacing: 0.5 },
            _react2.default.createElement(
              _gridColumn2.default,
              { sm: 6 },
              _react2.default.createElement(
                _InputModal2.default,
                {
                  buttonProps: buttonProps,
                  data: image ? { image: image, preview: form.values.image } : null,
                  type: 'image'
                },
                _react2.default.createElement(_inputImage2.default, _extends({}, inputProps, form.fields.image, {
                  orientationChange: orientationChange,
                  resizeOnUpload: resizeOnUpload,
                  width: width,
                  height: height,
                  onChange: function onChange(val) {
                    return _this4.handleChangeAttachment(val, 'image');
                  },
                  onFileChange: function onFileChange(val) {
                    return _this4.handleChangeAttachment(val, 'image');
                  }
                }))
              )
            ),
            _react2.default.createElement(
              _gridColumn2.default,
              { sm: 6 },
              _react2.default.createElement(
                _InputModal2.default,
                {
                  buttonProps: buttonProps,
                  data: video,
                  type: 'video',
                  width: 20
                },
                _react2.default.createElement(_inputVideo2.default, _extends({}, inputProps, form.fields.video, {
                  onChange: function onChange(val) {
                    return _this4.handleChangeAttachment(val, 'video');
                  },
                  onVideoChange: function onVideoChange(val) {
                    return _this4.handleChangeAttachment(val, 'video');
                  }
                }))
              )
            )
          )
        )
      );
    }
  }]);

  return CreatePostForm;
}(_react2.default.Component);

CreatePostForm.defaultProps = {
  height: 900,
  onSuccess: function onSuccess() {},
  orientationChange: true,
  resizeOnUpload: true,
  submit: 'Post Update',
  width: 1200
};

CreatePostForm.propTypes = {
  /**
   * Props to be passed to the Button component
   */
  buttonProps: _propTypes2.default.object,

  /**
   * Props to be passed to the Card component
   */
  cardProps: _propTypes2.default.object,

  /**
   * Props to be passed to the Form component
   */
  formProps: _propTypes2.default.object,

  /**
   * Image height in pixels
   */
  height: _propTypes2.default.number,

  /**
   * Props to be passed to the Input components
   */
  inputProps: _propTypes2.default.object,

  /*
   *
   */
  onSuccess: _propTypes2.default.func,

  /**
   * The page id to create the post for
   */
  pageId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  /**
   * The page owner's user token
   */
  token: _propTypes2.default.string.isRequired,

  /**
   * The label for the form submit button
   */
  submit: _propTypes2.default.string,

  /**
   * The page owner id (required for JG)
   */
  userId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Image width in pixels
   */
  width: _propTypes2.default.number
};

exports.default = (0, _withForm2.default)(_form2.default)(CreatePostForm);